import styled from 'styled-components';
import { Button } from '@mui/material';
import { StyledLink } from '../../../../../css/styledComponents.styles';
import * as fonts from '../../../../../css/fonts';
import colors, { colorBlack } from '../../../../../css/colors';

export const LinkButton = styled(StyledLink)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 4px;
  }
  text-transform: inherit;
  padding: 8px;
  width: 100% !important;
  height: auto;
  font-family: ${fonts.fontMedium};
  font-size: 0.8rem;
  font-weight: normal;
  ${({ isSelected }) => `color: ${isSelected ? colors.highlightTheme : colorBlack} !important`};
`;

export const DropdownButton = styled(Button)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 4px !important;
  }
  text-transform: initial !important;
  margin: 0 4px !important;
  padding: 0 8px !important;
  height: auto !important;
  font-family: ${fonts.fontMedium} !important;
  font-size: 0.8rem !important;
  font-weight: normal !important;
  ${({ btnColor }) => `color: ${btnColor} !important`};
`;

export const DropdownButtonText = styled.span`
  ${({ hasIcon }) => `margin-left: ${hasIcon ? '4px' : undefined}  !important`};
  margin-right: 6px;
  ${({ color }) => `color: ${color} !important`};
`;

export const TertiaryOptionsContainer = styled.div`
  padding: 0;
  margin: auto;
  display: flex;
`;

export const TertiaryRouteContainer = styled.div`
  align-content: center;
`;
